import React, { useState } from 'react';
import { toast } from "react-toastify";
import { Box, Typography, Divider, Button, Stack } from '@mui/material';
import { useOutletContext, useNavigate } from "react-router-dom";
import GoogleDriveUpload from './googleDrive';
import DropBoxUpload from './dropbox';
import OneDrivePicker from './oneDrive';
import { useDispatch, useSelector } from "react-redux";
import { uploadDocument } from "../../store/reducers/uploadDocumentSlice";
import Loader from '../Loader';
import { useLogger } from '../../hooks/useLogger';

export default function FileUpload() {
  const logEvent = useLogger();
  const fileInputRef = React.useRef(null);
  const { open } = useOutletContext();
  const [isHovered, setIsHovered] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profileData } = useSelector((state) => state.profile);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);
  const [loader, setLoader] = useState(false)
  // console.log(pdfEditortoken)
  const handleFileUpload = async (event) => {
    logEvent('Clicked', 'Upload Document', 'New-eSign');
    const file = event.target.files[0];
    if (file && pdfEditortoken?.access) {
      setLoader(true);
      try {
        await dispatch(uploadDocument({ token: pdfEditortoken.access, file })).unwrap();
      } catch (error) {
        console.error("Upload error:", error);
        toast.error(error || "Something went wrong");
      } finally {
        setLoader(false);
        event.target.value = null; 
      }
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    const file = event.dataTransfer.files[0];
    if (file && pdfEditortoken?.access) {
      setLoader(true);
      try {
        await dispatch(uploadDocument({ token: pdfEditortoken.access, file })).unwrap();
      } catch (error) {
        console.error("Upload error:", error);
        toast.error(error || "Something went wrong");
      } finally {
        setLoader(false);
        event.dataTransfer.clearData();
      }
    }
  };

  return (
    <>
    <Box
      sx={{
        flexGrow: 1,
        p: 3,
        width: open ? "calc(100% - 240px)" : "calc(100% - 100px)",
        marginLeft: open ? "240px" : "100px",
        transition: "margin 0.3s ease",
        height: "100vh",
        display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
        background: "#f9f9f9",
      }} 
    >
      <Box
        mt={10}
        style={{
          borderRadius: '12px',
          textAlign: 'center',
          background: '#fff',
          width: '100%',
          height: "calc(100% - 157px)",
          marginLeft: open ? "" : "1em",
        }}
      >
        <Box sx={{ height: '80px', alignContent:'center' }}>
          <Typography noWrap component="p" sx={{ fontSize: '22px', fontWeight: 600, lineHeight: '27.72px'}}>
            Upload Documents/Templates
          </Typography>
        </Box>
        <Divider sx={{ borderWidth : "1px", m: 0 }} />
        <Box
          sx={{
            borderRadius: '12px',
            textAlign: 'center',
            background: '#fff',
            width: "100%",
            display: "flex",
            height: "-webkit-fill-available"
          }}
        >
          <Box
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: '12px',
              textAlign: 'center',
              background: '#fff',
            }}
          >
            <Box 
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: 'center',
                cursor: 'pointer',
              }}
              onClick={() => fileInputRef.current?.click()}>
              <Box component="img" src={`${process.env.PUBLIC_URL}/images/upload.svg`} alt="logo" />
              <Typography 
                  variant="p" 
                  sx={{
                      mt: 2.5,
                      background: 'transparent',
                      color:'#22222', fontSize: '18px', fontWeight: '500'
                  }}
                  >Choose a file or Drag and Drop file here
              </Typography>

              <Typography 
                  variant="p" 
                  sx={{
                      mt: 1,
                      background: 'transparent',
                      fontSize: '14px', color: '#A3A3A3', fontWeight: '400'
                  }}
                  >Upload PDF (Max Size 50Mb)
              </Typography>
              
            </Box>
            <Button
              variant="contained"
              sx={{
                mt: 2.5,
                width: '155px',
                height: 46,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                boxShadow: "none",
                fontWeight: "500",
                "&:hover": { background: "#185CB7" },
              }}
              onClick={() => fileInputRef.current?.click()}
            >
              Upload File
            </Button>
            
            <input type="file" ref={fileInputRef} style={{ display: 'none' }} onChange={handleFileUpload} accept="application/pdf" />
            {/* <Box display="flex" alignItems="center" width="100%" justifyContent="center" sx={{ mt: 3 }}>
              <Divider
                sx={{
                  flex: 0.1,
                  height: "1px",
                  border: "none",
                  backgroundImage: "linear-gradient(to left, #D7D7D7 40%, transparent 100%)",
                }}
              />
              <Typography 
                variant="h6" 
                sx={{ mx: 2, color: "#9A9A9A", fontWeight: 400, fontSize: "14px" }}
              >
                Or Upload via
              </Typography>
              <Divider
                sx={{
                  flex: 0.1,
                  height: "1px",
                  border: "none",
                  backgroundImage: "linear-gradient(to right, #D7D7D7 40%, transparent 100%)",
                }}
              />
            </Box> */}

            {/* <Box mt={4} sx={{ width: "100%", display: "flex", gap: "63px", justifyContent: "center" }}>
              <GoogleDriveUpload />
              <OneDrivePicker/>
              <DropBoxUpload />
            </Box> */}
          </Box>

          <Divider orientation="vertical" flexItem sx={{ borderWidth: "0 0 0 thin !important", marginY: 2 }} />

          <Box sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "20px" }}>
            <Box component="img" src={`${process.env.PUBLIC_URL}/images/choose-template.svg`} alt="logo" />
            <Typography variant="p" sx={{ fontSize: '18px', fontWeight: 500, lineHeight: '28px', margin: "1em 6em 0 6em" }}>
              Find your perfect template. Set the tone and create something epic!
            </Typography>
            <Button
              variant="contained"
              sx={{
                mt: 4,
                width: '204px',
                height: 46,
                color: "#fff",
                background: "#185CB7",
                textTransform: "none",
                fontSize: "16px",
                borderRadius: "10px",
                boxShadow: "none",
                fontWeight: "500",
                "&:hover": { background: "#185CB7" },
              }}
              onClick={() => navigate("/esign/choose-template", { replace: true })}
            >
              Choose Template
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
    {loader && < Loader />}
    </>
  );
}
